// Pure lat-descending sort almost never ties, so a literal "then west→east" would be meaningless on
// real (slightly jittered) sampling grids. Instead points are banded into ROWS: walking
// north→south, a point starts a new row once it sits more than `tol` below the row's northernmost
// point, where tol scales with the latitude span and point count (a perfect r-row grid has row gaps
// of span/(r−1), and r ≈ √n for square-ish grids half a gap of slack absorbs GPS/placement jitter
// without merging real rows).
export function orderNorthSouthWestEast<P extends { lat: number; lng: number }>(
  points: P[],
): P[] {
  if (points.length <= 1) return [...points];
  const byLat = [...points].sort((a, b) => b.lat - a.lat);
  const span = byLat[0].lat - byLat[byLat.length - 1].lat;
  const tol = span / (2 * Math.sqrt(points.length));
  const rows: P[][] = [];
  let row: P[] = [];
  let rowTop = 0;
  for (const p of byLat) {
    if (row.length && rowTop - p.lat > tol) {
      rows.push(row);
      row = [];
    }
    if (!row.length) rowTop = p.lat;
    row.push(p);
  }
  rows.push(row);
  return rows.flatMap((r) => [...r].sort((a, b) => a.lng - b.lng));
}
